import React from "react";
import {
    Box,
    Typography,

    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow
} from "@mui/material";
import {} from "@mui/styles";

const TableDriver = (props) => {
    const {
        data
    } = props;

    return (
        <>

            <Typography variant="h5">
                Водители
            </Typography>

            <Box mt={1}/>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>№</TableCell>
                        <TableCell>Марка</TableCell>
                        <TableCell>Модель</TableCell>
                        <TableCell>Гос. номер</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(data || []).map((row, index) => (
                        <TableRow key={`table-row-${ index }`}>
                            <TableCell>{ row.id }</TableCell>
                            <TableCell>{ row.make }</TableCell>
                            <TableCell>{ row.model }</TableCell>
                            <TableCell>{ row.licensePlate }</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </>
    )
}

export default TableDriver
